
import {Address} from '../Address/address.model';

import {serializable, alias, object, list, primitive} from 'serializr';

export class Supplier { 

	@serializable(alias('id', primitive()))
	id?: number;

	@serializable(alias('name', primitive()))
	name?: string;

	@serializable(alias('company_id', primitive()))
	companyId?: number;

	@serializable(alias('address', object(Address)))
	address?: Address;

	@serializable(alias('createdAt', primitive()))
	createdAt?: string;

	@serializable(alias('updatedAt', primitive()))
	updatedAt?: string;

}